<template>
  <div class="full-screen-diagnosis">
    <popup ref="disgnosisiPopup" full-screen :visible="true" :show-choose="false">
      <div class="full-screen-diagnosis-charts">
        <div class="hor-operation-area">
          <!-- 关闭按钮 -->
          <div class="close-btn" @click="hide">
            <i class="crm-Icon-claim-vist" />
          </div>
          <div class="chart-name">{{ title }}</div>
          <!-- 图表切换 -->
          <div class="chart-pagenation">
            <div class="hot-area-left-btn" @click="preChart">
              <div
                :class="{
                  'check-step-btn': true,
                  'btn-left': true,
                  'btn-disabled': isButtonDisabledPre,
                }"
              >
                <i class="crm-Icon_right" />
              </div>
            </div>
            <div class="step-progress">{{ stepProgress }}</div>
            <div class="hot-area-right-btn" @click="nextChart">
              <div
                :class="{
                  'check-step-btn': true,
                  'btn-disabled': isButtonDisabledNext,
                }"
              >
                <i class="crm-Icon_right" />
              </div>
            </div>
          </div>
        </div>
        <!-- 巴西 BR -->
        <template v-if="isBR">
          <DiagnosisItemBR
            :data="horChartData"
            :direction="direction"
            :show-compare-info="showCompareInfo"
          />
        </template>
        <!-- 非巴西 SSL -->
        <template v-else>
          <DiagnosisItem
            :data="horChartData"
            :direction="direction"
            :show-compare-info="showCompareInfo"
          />
        </template>
      </div>
    </popup>
  </div>
</template>
<script>
import Popup from '@/components/Popup'
import DiagnosisItem from '../DiagnosisItem/index.vue'
import DiagnosisItemBR from '../DiagnosisItemBR/index.vue'
import { getBDCountry } from '@/common/utils/i18n'

export default {
  name: 'FullHorShowChart',
  components: {
    Popup,
    DiagnosisItem,
    DiagnosisItemBR,
  },
  props: {
    showCompareInfo: {
      type: Boolean,
      default: false,
    },
    chartIndex: {
      type: Number,
      default: 0,
    },
    diagnosisData: {
      type: Array,
      default: () => {
        return []
      },
    },
    direction: {
      type: String,
      default: 'vertical',
    },
  },
  data() {
    return {}
  },
  computed: {
    isBR() {
      return getBDCountry() === 'BR'
    },
    curIndex: {
      get() {
        return this.chartIndex
      },
      set(newValue) {
        this.$emit('click', newValue)
      },
    },
    title() {
      return this.horChartData && this.horChartData.title
    },
    isButtonDisabledPre() {
      return this.curIndex <= 0
    },
    isButtonDisabledNext() {
      return this.curIndex + 1 >= this.diagnosisDataLen
    },
    diagnosisDataLen() {
      return this.diagnosisData.length
    },
    stepProgress() {
      return `${this.curIndex + 1}/${this.diagnosisDataLen}`
    },
    horChartData() {
      return this.diagnosisData[this.curIndex]
    },
  },
  created() {
    console.log('[log]created')
  },
  methods: {
    preChart() {
      if (this.curIndex >= 1) {
        this.curIndex = this.curIndex - 1
      }
    },
    nextChart() {
      if (this.curIndex < this.diagnosisDataLen - 1) {
        this.curIndex = this.curIndex + 1
      }
    },
    show() {
      this.$refs.disgnosisiPopup.show()
    },
    hide() {
      this.$refs.disgnosisiPopup.hide()
    },
  },
}
</script>

<style lang="scss">
.hor-operation-area {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .close-btn {
    width: 120px;
    height: 100px;
    display: flex;
    align-items: center;
    .crm-Icon-claim-vist {
      color: #000;
      font-size: 32px;
      margin-left: 48px;
    }
  }
  .chart-pagenation {
    display: flex;
    .step-progress {
      line-height: 100px;
      height: 100px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #8d9099;
      font-weight: 400;
      margin: 0 24px;
    }
    .hot-area-left-btn {
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .hot-area-right-btn {
      width: 88px;
      display: flex;
      height: 100px;
      justify-content: flex-start;
      align-items: center;
    }
    .check-step-btn {
      width: 40px;
      height: 40px;
      background: #f0f1f5;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 24px;
        color: #595c66;
      }
    }
    .btn-left {
      transform: scaleX(-1);
    }
    .btn-disabled {
      background: #f0f1f5;
      i {
        color: #c4c6cc;
      }
    }
  }
}
.full-screen-diagnosis {
  overflow: hidden;
  height: 100%;
  position: relative;
  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }
}
.full-screen-diagnosis-charts {
  width: calc(100vh - var(--barheight));
  height: 100vw;
  transform: rotate(90deg);
  transform-origin: left top;
  margin-left: 100vw;
  padding-left: var(--barheight);
}
</style>
